import Vue from "vue";
import Vuex from "vuex";
import DenominationsService from "@/services/DenominationsService";
import produitsService from "@/services/ProduitsService";
import fournisseursService from "@/services/FournisseursService";
import denominationService from "@/services/DenominationsService";
import mcService from "@/services/MultiCritsService";

Vue.use(Vuex);

export const actions = {
  async fetchResultats({ commit, state }, payload) {
    let { recherche, type, page } = payload;
    let id = 0;
    let response;
    let deno = null;

    if (type == null) {
      type = state.recherche.type;
    }

    if (recherche == null) {
      recherche = state.recherche.texte;
      //}else if ( typeof(recherche) == 'object' ) {
    } else if (parseInt(recherche) > 0) {
      id = parseInt(recherche);
      if (type == 4 || type == 5) {
        // déno par son id
        response = await denominationService.getDenomination(id);
        deno = response.data;
        recherche = response.data.libelle;
        // reste à gérer si eqv
        if (deno.idDenoPrincipale > 0) {
          id = deno.idDenoPrincipale;
        }
      } else if (type == 6 || type == 7) {
        //frn par son id
        response = await fournisseursService.getFournisseur(id);
        recherche = response.data.nom;
      }
    }

    if (page == null) {
      page = 1;
    }

    switch (type) {
      case 1:
        response = await DenominationsService.getDenominations(recherche, page);
        break;
      case 2:
        response = await fournisseursService.getFournisseurs(recherche, page);
        break;
      case 3:
        response = await produitsService.getProduits(recherche, page);
        break;
      case 4:
      case 5:
        // fournisseurs ou produits d'une déno
        response = await produitsService.getProduitsDenomination(id, page);
        break;
      case 6:
      case 7:
        // dénos ou produits d'un fournisseur
        response = await produitsService.getProduitsFournisseur(id, page);

        break;
      case 8:
        // multi-criteres
        console.log("page", page);
        response = await mcService.getProduits(recherche, page);
        break;
      default:
        throw new Error("Type recherche inexistant");
    }

    if (response.status == 200) {
      commit("SET_RECHERCHE_TEXTE", recherche);
      commit("SET_RECHERCHE_TYPE", type);
      commit("SET_PAGE", page);
      commit("SET_RECHERCHE_RESULTATS_ITEMS", response.data);
      commit(
        "SET_RECHERCHE_RESULTATS_NB_DENOS",
        parseInt(response.headers["x-total-denos-count"])
      );
      commit(
        "SET_RECHERCHE_RESULTATS_NB_FRNS",
        parseInt(response.headers["x-total-fournisseurs-count"])
      );
      commit(
        "SET_RECHERCHE_RESULTATS_NB_TOTAL",
        parseInt(response.headers["x-total-count"])
      );
      commit(
        "SET_RECHERCHE_RESULTATS_NB_PDTS",
        parseInt(response.headers["x-total-produits-count"])
      );
    }
  },
  setInfosFicheDM({ commit }, payload) {
    const { nomProduit } = payload;
    commit("SET_RECHERCHE_TYPE", 8);
    commit("SET_RECHERCHE_TEXTE", nomProduit);
  },
};

export default new Vuex.Store({
  state: {
    loading: false,
    recherche: {
      type: null,
      texte: null,
      page: 1,
      resultats: {
        nbTotal: null,
        nbDenos: null,
        nbFrns: null,
        nbPdts: null,
        items: [],
      },
    },
  },
  getters: {},
  mutations: {
    SET_RECHERCHE_TEXTE(state, texte) {
      state.recherche.texte = texte;
    },
    SET_RECHERCHE_RESULTATS_ITEMS(state, payload) {
      state.recherche.resultats.items = payload;
    },
    SET_RECHERCHE_RESULTATS_NB_DENOS(state, payload) {
      state.recherche.resultats.nbDenos = payload;
    },
    SET_RECHERCHE_RESULTATS_NB_FRNS(state, payload) {
      state.recherche.resultats.nbFrns = payload;
    },
    SET_RECHERCHE_RESULTATS_NB_PDTS(state, payload) {
      state.recherche.resultats.nbPdts = payload;
    },
    SET_RECHERCHE_RESULTATS_NB_TOTAL(state, payload) {
      state.recherche.resultats.nbTotal = payload;
    },
    SET_RECHERCHE_TYPE(state, payload) {
      state.recherche.type = payload;
    },
    SET_PAGE(state, payload) {
      state.recherche.page = payload;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
  },
  actions,
  // modules: {},
});
